import { isLate } from "@utils/datetime";

/**
 * Funções puras para cálculo de atrasos de eventos.
 * Usadas por prepareEventForDisplay e shouldShowLateIcon.
 */

/**
 * Verifica se o processo não iniciou e passou do início previsto
 * Retorna true se passou do plannedExecutionStart (início previsto)
 * Usado para marcar START quando passou do início previsto mas não iniciou
 */
export function calculateNotStartedAndStartPassed(
  executionStart: string | null | undefined,
  plannedExecutionStart: string | null | undefined
): boolean {
  return !executionStart &&
    Boolean(plannedExecutionStart) &&
    isLate(plannedExecutionStart);
}

/**
 * Verifica se o processo não iniciou e passou do fim previsto
 * Retorna true se passou do plannedExecutionEnd (fim previsto)
 * Usado quando passou do fim previsto e não iniciou nem finalizou → pinta START e END
 */
export function calculateNotStartedAndEndPassed(
  executionStart: string | null | undefined,
  executionEnd: string | null | undefined,
  plannedExecutionEnd: string | null | undefined
): boolean {
  return !executionStart &&
    !executionEnd &&
    Boolean(plannedExecutionEnd) &&
    isLate(plannedExecutionEnd);
}

/**
 * Verifica se o processo iniciou atrasado
 * Retorna true apenas se executionStart > plannedExecutionStart (não igual)
 */
export function calculateStartedLate(
  executionStart: string | null | undefined,
  plannedExecutionStart: string | null | undefined
): boolean {
  if (!executionStart || !plannedExecutionStart) {
    return false;
  }

  const executionTime = new Date(executionStart).getTime();
  const plannedTime = new Date(plannedExecutionStart).getTime();
  return executionTime > plannedTime;
}

/**
 * Verifica se o processo finalizou com atraso
 * Retorna true se executionEnd > plannedExecutionEnd
 */
export function calculateEndedLate(
  executionEnd: string | null | undefined,
  plannedExecutionEnd: string | null | undefined
): boolean {
  if (!executionEnd || !plannedExecutionEnd) {
    return false;
  }

  const executionTime = new Date(executionEnd).getTime();
  const plannedTime = new Date(plannedExecutionEnd).getTime();
  return executionTime > plannedTime;
}

/**
 * Verifica se apenas o fim está atrasado (iniciou mas não finalizou e passou do previsto)
 */
export function calculateOnlyEndLate(
  executionStart: string | null | undefined,
  executionEnd: string | null | undefined,
  plannedExecutionEnd: string | null | undefined
): boolean {
  return Boolean(executionStart) &&
    !executionEnd &&
    Boolean(plannedExecutionEnd) &&
    isLate(plannedExecutionEnd);
}

/**
 * Verifica se AWAITING_END está atrasado
 * AWAITING_END nunca tem executionStart, só está atrasado se passou do plannedExecutionEnd sem executionEnd
 */
export function calculateAwaitingEndLate(
  executionEnd: string | null | undefined,
  plannedExecutionEnd: string | null | undefined
): boolean {
  return !executionEnd &&
    Boolean(plannedExecutionEnd) &&
    isLate(plannedExecutionEnd);
}
